<template>
    <div class="sr-link-list-group">
        <SrHeadline>
            {{ group.title }}
        </SrHeadline>
        <SrLinkListItem v-for="(item, index) in group.items" :key="index" v-bind="item" />
    </div>
</template>

<script>
import { SrHeadline } from '../SrHeadline';
import SrLinkListItem from './SrLinkListItem';

export default {
    name: 'SrLinkListGroup',
    components: { SrHeadline, SrLinkListItem },
    props: {
        group: {
            type: Object,
            default: () => ({
                title: '',
                items: [],
            }),
            validator(group) {
                const titlePropertyExists = Object.prototype.hasOwnProperty.call(group, 'title');
                const itemsPropertyExists = Object.prototype.hasOwnProperty.call(group, 'items');

                return titlePropertyExists && itemsPropertyExists;
            },
        },
    },
};
</script>
